import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { useNonPreferedSuppliersContext } from 'contexts/CategoryInsightsKpi/NonPreferedSuppliersProvider';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const NonPreferedSuppliersExplore = () => {
	const { gridData } = useNonPreferedSuppliersContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of non-preferred suppliers as marked by the entity.`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default NonPreferedSuppliersExplore;
